import { MultiClientConfigKeySchema } from '../../../shared/common/types/multi-client.types';

export const useClientAppRedirect = () => {
  const CLIENT = window.env.CLIENT;

  if (CLIENT === MultiClientConfigKeySchema.enum.demo && window.location.pathname === '/') {
    window.location.href = '/gpt';
  }
};
